import React from 'react';
import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { usePreviewState } from '@wix/editor-elements-preview-utils';
import type {
  IComponentPreviewWrapper,
  IDefaultPreviewWrapperProps,
} from '@wix/editor-elements-types/thunderboltPreview';
import type {
  IPaginationPreviewMapperProps,
  IPaginationProps,
} from '../Pagination.types';
import { classes } from './style/Pagination.st.css';

function withComponentPreview(
  WrappedComponent: React.ComponentType<IPaginationProps>,
): IComponentPreviewWrapper<
  IPaginationProps,
  IDefaultPreviewWrapperProps & IPaginationPreviewMapperProps
> {
  return ({ previewWrapperProps = {}, ...viewerProps }) => {
    const { compPreviewState, componentViewMode } = previewWrapperProps;
    const isEditor = componentViewMode === 'editor';

    usePreviewState(viewerProps.id, compPreviewState, {
      disabled: {
        selectors: `.${classes.navButton}`,
        type: 'plural',
      },
    });

    return <WrappedComponent {...viewerProps} isOnStage={isEditor} />;
  };
}

export default (ViewerComponent: React.ComponentType<IPaginationProps>) =>
  createComponentPreviewEntry(withComponentPreview(ViewerComponent));
